import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-overview" }
const _hoisted_2 = { class: "app-overview__description" }
const _hoisted_3 = {
  key: 0,
  class: "app-overview__images-container"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "app-overview__video-container"
}
const _hoisted_6 = ["src"]

import { useStore } from 'vuex';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppOverview',
  setup(__props) {

const store = useStore();
const currentApp = computed(() => store.getters.currentApp);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(currentApp.value.longDescription), 1)
    ]),
    (currentApp.value.images && currentApp.value.images.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentApp.value.images, (image, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "app-overview__image-container",
              key: `${currentApp.value.id}-image-${index}`
            }, [
              _createElementVNode("img", {
                class: "app-overview__image",
                src: image,
                alt: `${currentApp.value.name} screenshot`
              }, null, 8, _hoisted_4)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (currentApp.value.video)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("iframe", {
            src: currentApp.value.video,
            title: "Video player",
            frameborder: "0",
            allowfullscreen: ""
          }, null, 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})